"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DedupLogger = void 0;
class DedupLogger {
    constructor(duration = 3 * 60 * 1000, impl = console.log) {
        this.impl = impl;
        this.logCache = {};
        this.disposed = false;
        this.duration = duration;
        this.scheduleCacheCleanup();
    }
    dispose() {
        this.disposed = true;
    }
    log(key, ...message) {
        const now = new Date().getTime();
        // Check if the key exists in the cache and if the last logged time is within the specified duration
        if (this.logCache[key] && now - this.logCache[key].timestamp < this.duration) {
            this.logCache[key].count += 1;
            return;
        }
        this.impl(...message);
        // Update the cache with the current time and count of 1
        this.logCache[key] = {
            count: 1,
            timestamp: now,
        };
    }
    scheduleCacheCleanup() {
        if (this.disposed)
            return;
        setTimeout(() => {
            if (this.disposed)
                return;
            const now = new Date().getTime();
            // Iterate over all cache entries and remove old entries
            Object.keys(this.logCache).forEach((key) => {
                if (now - this.logCache[key].timestamp >= this.duration) {
                    const repeatedCount = this.logCache[key].count - 1;
                    this.impl(`[message ${key} repeated ${repeatedCount} times in ${this.duration / 1000} seconds]`);
                    delete this.logCache[key];
                }
            });
            // Schedule the next cleanup
            this.scheduleCacheCleanup();
        }, this.duration);
    }
}
exports.DedupLogger = DedupLogger;
//# sourceMappingURL=DedupLogger.js.map